if (!window.__toptanCarouselBound) {
  window.__toptanCarouselBound = true;

  const motion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';

  function updateCarousel(track) {
    const cards = [...track.children];
    const dots = document.querySelector(`[data-toptan-dots][aria-controls="${track.id}"]`);
    const controls = document.querySelectorAll(`[data-toptan-slide][aria-controls="${track.id}"]`);
    if (!cards.length) return;

    const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
    const step = cards[0].getBoundingClientRect().width + gap;
    const visible = Math.max(1, Math.round((track.clientWidth + gap) / step));
    const pages = Math.max(1, cards.length - visible + 1);
    const active = Math.min(pages - 1, Math.max(0, Math.round(track.scrollLeft / step)));

    if (dots && dots.children.length !== pages) {
      dots.replaceChildren();
      for (let index = 0; index < pages; index += 1) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', `${index + 1}. karta git`);
        dot.dataset.toptanDot = String(index);
        dots.append(dot);
      }
    }
    if (dots) {
      dots.hidden = pages < 2;
      [...dots.children].forEach((dot, index) => dot.setAttribute('aria-current', String(index === active)));
    }
    controls.forEach((button) => {
      button.disabled = button.dataset.toptanSlide === 'prev' ? active === 0 : active >= pages - 1;
    });
  }

  function initializeCarousels(root = document) {
    root.querySelectorAll('[data-toptan-dots]').forEach((dots) => {
      const track = document.getElementById(dots.getAttribute('aria-controls'));
      if (!track) return;
      if (!track.dataset.toptanCarouselReady) {
        track.dataset.toptanCarouselReady = 'true';
        track.addEventListener('scroll', () => updateCarousel(track), { passive: true });
      }
      updateCarousel(track);
    });
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-toptan-slide], [data-toptan-dot]');
    if (!button) return;

    const track = document.getElementById(button.getAttribute('aria-controls') || button.parentElement.getAttribute('aria-controls'));
    const card = track?.firstElementChild;
    if (!track || !card) return;

    const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
    const step = card.getBoundingClientRect().width + gap;
    const index = button.dataset.toptanDot;
    const left = index === undefined
      ? track.scrollLeft + (button.dataset.toptanSlide === 'prev' ? -step : step)
      : Number(index) * step;
    track.scrollTo({ left, behavior: event.detail === 0 ? 'instant' : motion() });
  });

  document.addEventListener('DOMContentLoaded', () => initializeCarousels());
  document.addEventListener('shopify:section:load', (event) => initializeCarousels(event.target));
  window.addEventListener('resize', () => document.querySelectorAll('[data-toptan-dots]').forEach((dots) => {
    const track = document.getElementById(dots.getAttribute('aria-controls'));
    if (track) updateCarousel(track);
  }), { passive: true });

  if (document.readyState !== 'loading') initializeCarousels();
}
